import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from '../../styles';

const NotEnteredIntoPrizeDraw = ({ raceName }) => (
    <>
        <Styled.Heading>You&#39;re not in the Prize Draw!</Styled.Heading>
        <Styled.Text>
            Your horse didn&#39;t win the {raceName} race. You have not been
            entered into the Prize Draw.
        </Styled.Text>
    </>
);

NotEnteredIntoPrizeDraw.propTypes = {
    raceName: PropTypes.string.isRequired
};

export default NotEnteredIntoPrizeDraw;
